import { EmployeeWithReportedPayrollViewModel } from '@fora-monorepo/employer-my-pages-common/types';
import { ALL_OPTION, OptionType } from '@foradevelopment/fora-ui';

import { formatEmployeeId } from '../../common/utils';
import { typedT } from '../../i18n/i18n';

export const allIndividualsOption: OptionType = {
  name: typedT('filter.selectorLabels.selectAllEmployees'),
  id: ALL_OPTION,
  bold: true,
};

export const getEmployeesWithReportedPayrollOptions = (
  employeesOptions: EmployeeWithReportedPayrollViewModel[]
): OptionType[] => {
  const options: OptionType[] = [allIndividualsOption];

  employeesOptions.forEach(x => {
    options.push({
      id: x.partnerNumberIndividual,
      name: `${x.firstName} ${x.lastName}`,
      description: formatEmployeeId(x.employeeId),
    });
  });

  return options;
};
